import type { InfoCardProps } from "@components/InfoCardProps.js";
import type { Tenant } from "@core/schema/Tenant.js";
import { getDigitalizationAndAutomationPath } from "@core/schema/paths/getDigitalizationAndAutomationPath.js";

export function getAccountingWhyFastest(tenant: Tenant): InfoCardProps[] {
	return [
		{
			desc: "sp[[Ušetříme]] vám čas s papírováním i personální náklady.",
		},
		{
			desc: "Řešení připravíme sp[[100% na míru]] vašemu podnikání.",
		},
		{
			desc: `Kromě účetnictví kompletně [${getDigitalizationAndAutomationPath(tenant)}][[digitalizujeme a automatizujeme]] i objednávkový proces.`,
		},
		{
			desc: "sp[[Zmapujeme]] vaši aktuální situaci, odhalíme neefektivní procesy a navrhneme optimalizaci.",
		},
		{
			desc: "Postaráme se o všechny legislativní náležitosti spojené s digitalizací a automatizací účetnictví, takže se sp[[nemusíte o nic starat]].",
		},
		{
			desc: "Účetnictví jsme sp[[digitalizovali a automatizovali]] pro významné firmy napříč odvětvími. ",
		},
	];
}
